// @ts-check

export default class {
  constructor(element) {
    this.element = element;
    this.__initializeModule();
  }
  
  onInit() {}

  __initializeModule() {
    if(typeof this.onInit === "function") {
      this.onInit();
    }
    this.element.classList.add('is-initialized')
  }
}